(function () {
  'use strict';
  var toggle = document.querySelector('.nav-toggle');
  var drawer = document.getElementById('drawer');
  if (toggle && drawer) {
    var close = drawer.querySelector('.drawer__close');
    var open = function (state) {
      if (state) { drawer.setAttribute('open', ''); } else { drawer.removeAttribute('open'); }
      toggle.setAttribute('aria-expanded', String(state));
      document.body.style.overflow = state ? 'hidden' : '';
      if (state) { drawer.querySelector('a').focus(); } else { toggle.focus(); }
    };
    toggle.addEventListener('click', function () { open(!drawer.hasAttribute('open')); });
    if (close) { close.addEventListener('click', function () { open(false); }); }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) { open(false); }
    });
  }

  var groups = [
    { sel: '.variants__options .variant', attr: 'aria-pressed' },
    { sel: '.filters .chip', attr: 'aria-pressed' }
  ];
  groups.forEach(function (g) {
    var items = Array.prototype.slice.call(document.querySelectorAll(g.sel));
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.disabled) { return; }
        items.forEach(function (other) { other.setAttribute(g.attr, 'false'); });
        item.setAttribute(g.attr, 'true');
      });
    });
  });

  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery__thumbs .thumb'));
  var main = document.getElementById('pdp-main-image');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      var full = thumb.getAttribute('data-full');
      if (main && full) { main.removeAttribute('srcset'); main.src = full; }
    });
  });

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animated = document.querySelectorAll('.reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(animated, function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    Array.prototype.forEach.call(animated, function (el) { io.observe(el); });
  }
}());
